/* eslint-disable react/no-danger */
import React from 'react';
import Modal from 'react-modal';
import SearchFilter from 'search/SearchFilter';
import ProviderList from './ProviderList';
import Tier1ProviderGrid from './Tier1ProviderGrid';

// empty the modal's default styles
Modal.defaultStyles = {};

function getTier1Providers(providers) {
    return providers.filter((provider) => (provider.tier === 1));
}

class ProviderDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { searchFilter: '' };
        this.onFilterInputChange = this.onFilterInputChange.bind(this);
    }

    onFilterInputChange(event) {
        this.setState({ searchFilter: event.target.value });
    }

    render() {
        const {
            closeModal,
            providers,
            providerSelect,
            showProviderDialog,
            title,
            description,
            subtitle,
            tier1Subtitle,
            placeholder
        } = this.props;
        const tier1Providers = getTier1Providers(providers);
        const tier1Grid = tier1Providers.length > 0 ? (
            <div>
                <h2 className="watchProvider__sub-title">
                    {tier1Subtitle}
                </h2>
                <Tier1ProviderGrid providers={tier1Providers} providerSelect={providerSelect} />
            </div>) : null;
        const transparentMask = showProviderDialog ? <div className="js-feed-item-mask active" /> : null;
        return (
            <div>
                {transparentMask}
                <Modal isOpen={showProviderDialog} onRequestClose={closeModal} overlayClassName="lightbox-container">
                    <article className="lightbox-watch watch-provider-modal js-bloomed">
                        <div className="btn-close icon-font-before icon-close-solid-before" onClick={closeModal} />
                        <section className="watchProvider--modal">
                            <h1 className="watchProvider__title">
                                <span>{title}</span>
                            </h1>
                            <div className="watchProvider__scroll">
                                <p
                                    className="watchProvider__desc"
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                                {tier1Grid}
                                <h2 className="watchProvider__sub-title">
                                    {subtitle}
                                </h2>
                                <SearchFilter
                                    handleChange={this.onFilterInputChange}
                                    placeholder={placeholder}
                                />
                                <ProviderList
                                    filter={this.state.searchFilter}
                                    providers={providers}
                                    providerSelect={providerSelect}
                                />
                            </div>
                        </section>
                    </article>
                </Modal>
            </div>
        );
    }
}

ProviderDialog.propTypes = {
    closeModal: React.PropTypes.func,
    providers: React.PropTypes.array,
    providerSelect: React.PropTypes.func,
    showProviderDialog: React.PropTypes.bool,
    title: React.PropTypes.string.isRequired,
    description: React.PropTypes.string.isRequired,
    tier1Subtitle: React.PropTypes.string.isRequired,
    subtitle: React.PropTypes.string.isRequired,
    placeholder: React.PropTypes.string.isRequired
};

ProviderDialog.defaultProps = {
    providers: [],
    showProviderDialog: false
};

export default ProviderDialog;



// WEBPACK FOOTER //
// ./app/modal/authn/ProviderDialog.js